/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement } from 'react';
import { ErrorPage } from '@components';
import { useFormikContext } from 'formik';
import { iThirdPartyFormValues } from '@services/ThirdPartyService';

function TPErrorPage(): ReactElement {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { values }: { values: iThirdPartyFormValues } = useFormikContext();
    return (
      <>
        <ErrorPage errorMessage={values.submissionError} />
      </>
    );
}

export default TPErrorPage;
